import client from "./client";

export type ManagementItem = {
  type: string;
  id: string;
  name: string;
  owner_name: string | null;
  status: string;
  cadence: string | null;
  last_run_at: string | null;
  credits: number | null;
  cost_gbp: number | null;
  note: string | null;
};

export type ManagementSummary = {
  period_days: number;
  total_credits: number;
  total_cost_gbp: number;
  chat_credits: number;
  chat_cost_gbp: number;
  scheduled_credits: number;
  scheduled_cost_gbp: number;
};

export type ManagementItemParams = { status?: string; days?: number };

export const managementApi = {
  getItems: (params: ManagementItemParams = {}) => {
    const { status, days } = params;
    return client.get<ManagementItem[]>("/management/items", {
      params: { ...(status ? { status } : {}), ...(days ? { days } : {}) },
    });
  },
  getSummary: (days = 30) =>
    client.get<ManagementSummary>("/management/summary", { params: { days } }),
  setActive: (type: string, id: string, isActive: boolean) =>
    client.patch<ManagementItem>(`/management/items/${type}/${id}/active`, { is_active: isActive }),
};
